var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationCircle = function SvgExclamationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 .375C5.58.375.375 5.582.375 12 .375 18.422 5.58 23.625 12 23.625S23.625 18.422 23.625 12C23.625 5.582 18.42.375 12 .375m0 21A9.37 9.37 0 0 1 2.625 12 9.37 9.37 0 0 1 12 2.625 9.37 9.37 0 0 1 21.375 12 9.37 9.37 0 0 1 12 21.375m1.969-4.875A1.97 1.97 0 0 1 12 18.469a1.97 1.97 0 0 1-1.969-1.969c0-1.086.883-1.969 1.969-1.969s1.969.883 1.969 1.969m-3.814-9.91.318 6.376c.015.299.262.534.562.534h1.93c.3 0 .547-.235.562-.534l.319-6.375A.563.563 0 0 0 13.284 6h-2.568a.563.563 0 0 0-.561.59"
  })));
};
export default SvgExclamationCircle;